export default "__VITE_ASSET__Bekm54Sl__"